import { useState, useEffect } from "react";

export const useDeviceDetection = () => {
    const [isMobile, setIsMobile] = useState<boolean>(false);

    useEffect(() => {
        const checkDevice = () => {
            // If user is on a mobile route, always lock to mobile mode
            // This prevents 404 errors when orientation changes
            const pathname = window.location.pathname;
            if (pathname.startsWith('/mobile')) {
                setIsMobile(true);
                return;
            }

            // Otherwise, use screen width to determine mobile/desktop
            setIsMobile(window.innerWidth < 768);
        };

        // Initial check
        checkDevice();

        // Add listener for resize events (including orientation changes)
        window.addEventListener("resize", checkDevice);

        // Also listen to popstate events (back/forward navigation)
        window.addEventListener("popstate", checkDevice);

        // Cleanup
        return () => {
            window.removeEventListener("resize", checkDevice);
            window.removeEventListener("popstate", checkDevice);
        };
    }, []);

    return { isMobile };
};
